/**
 * Checks run before a Canada Post label is bought (T-103, T-116).
 *
 * The one thing that goes wrong is a label created for a case with no ship
 * day: it files under no day on the deliveries list and joins no label run
 * (case 851). Pickup dates and other crematoria don't matter — each
 * crematorium has its own independent Canada Post schedule.
 */
import { isPickupMethod } from './pickupDateTbd';

export interface SafetyWarning {
  kind: 'no_ship_day';
  message: string;
}

/** "Rideau Funeral Home" → "Rideau"; the pills use the short name. */
export const crematoriumShortName = (name?: string | null): string =>
  (name || '').trim().replace(/\s+funeral\s+home$/i, '') || 'Unknown';

export const NO_SHIP_DAY_MESSAGE = 'This case has no ship day yet. Set one so it shows on the deliveries list.';

/**
 * Warnings for buying a label for one case: only a missing ship day. A pickup
 * never ships, so it never warns — a pickup with no day is waiting on the
 * family, not on a ship day (T-175).
 */
export const labelWarnings = ({
  deliveryDay,
  deliveryMethod,
}: {
  deliveryDay?: string | null;
  deliveryMethod?: string | null;
}): SafetyWarning[] =>
  deliveryDay || isPickupMethod(deliveryMethod) ? [] : [{ kind: 'no_ship_day', message: NO_SHIP_DAY_MESSAGE }];
